"use client";

import { IProductBundle } from "@/api/AppApi/services/home/interfaces/IProductBundle";
import { IBundleItem } from "@/api/AppApi/services/product/interfaces/product-bundle-types";
import React, { useMemo } from "react";
import SvgBundleArrows from "./components/SvgBundleArrows";
import { BundleProductContextProvider } from "./context/BundleProductContext";
import BundleActions from "./components/bundle-actions";
import { useIsSmallScreen } from "./hooks/useIsSmallScreen";
import { useIsMobile } from "@/hooks/useIsMobile";
import { generateBundleItems } from "../../pages-components/product-details-page/bundle/functions";
import ItemsSection from "./items-section";

const ProductsBundle: React.FC<IProductBundle> = ({ data }) => {
  const { product, title } = data ?? {};
  const products = product.bundle_items;

  // Create array with products and plus icons
  const createSliderItems = (products?: IBundleItem[]) => {
    const items: {
      type: "product" | "plus";
      data?: IBundleItem;
      id: string;
      index: number;
    }[] = [];

    products?.forEach((product, index) => {
      items.push({
        type: "product",
        data: product,
        id: `product-${product.id}`,
        index: index,
      });
      if (index < products.length - 1) {
        items.push({
          type: "plus",
          id: `plus-${index}`,
          index: -1,
        });
      }
    });

    return items;
  };

  const processedItems = products?.flatMap(generateBundleItems);
  const sliderItems = useMemo(() => createSliderItems(processedItems), []);

  const isSamllScreen = useIsSmallScreen();
  const isMobile = useIsMobile();
  console.log({sliderItems})
  
  return (
    <BundleProductContextProvider product={product}>
      <div className="product-bundle-component">
        <div className="title"> {title}</div>
        <div
          className="product-bundle"
          style={
            isSamllScreen
              ? {
                  flexDirection: "column",
                  alignItems: "flex-start",
                  maxWidth: "fit-content",
                  width: "auto",
                }
              : {}
          }
        >
          <div
            style={{ maxWidth: isSamllScreen ? "100%" : "70%", width: "auto" }}
          >
            <ItemsSection sliderItems={sliderItems} />
          </div>

          <div
            className="bundle-price-details "
            style={isSamllScreen ? { maxWidth: "100%" } : {}}
          >
            {!isMobile && <ArrowsIcon />}
            <BundleActions />
          </div>
        </div>
      </div>
    </BundleProductContextProvider>
  );
};

export default ProductsBundle;

const ArrowsIcon = () => (
  <div className="bundle-plus" style={{ width: 36 }}>
    <SvgBundleArrows />
  </div>
);
